import { Injector } from '@angular/core';
import { map } from 'rxjs';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { QuotationService } from 'src/app/CRM/quotation/quotation.service';
import { DocEmailProfile } from './document-email.types';

function scope(injector: Injector) {
  const user = injector.get(UserLoginService).User();
  return { tenantId: user.companyId, tenantBranchId: user.loggedInBranchId };
}

/** Sale Quotation (Print page MasterType = SaleQuotation). */
const SALE_QUOTATION: DocEmailProfile = {
  masterType: 'SaleQuotation',
  label: 'Quotation',
  menuCode: 'quotation',
  objectCode: 'QMEMAILPRV',
  templateKeyword: 'quot',
  requestKey: id => `QUOT:${id}`,
  defaults: { allowedStatuses: ['DFT', 'DRAFT'], statusOnSend: 'SNT' },
  statusLabels: { DFT: 'Draft', DRAFT: 'Draft', SNT: 'Sent', SENT: 'Sent', ACPT: 'Accepted', RJT: 'Rejected', EXP: 'Expired' },
  builtInTemplate: {
    subject: 'Quotation {{QuotationNumber}} dated {{QuotationDate}}',
    body: '<p>Dear {{CustomerName}},</p><p>Our quotation <b>{{QuotationNumber}}</b> dated {{QuotationDate}} has been shared with you.</p><p>For any queries, please reply to this email.</p>'
  },
  load: (injector, id) => injector.get(QuotationService)
    .QuotationMaster_ReadById({ quotationId: id, ...scope(injector) })
    .pipe(map(q => ({
      number: q?.quotationNumber || '',
      status: q?.status || '',
      relationId: q?.clientCompanyId || 0,
      values: { ...(q as unknown as Record<string, unknown>) }
    }))),
  setStatus: (injector, id, status, actionUser) => injector.get(QuotationService)
    .QuotationMaster_updateStatus({ quotationId: id, ...scope(injector), status, notes: 'Email requested', actionUser })
};

/**
 * Document types that support the email preview. To add one (e.g. a Sales Invoice print):
 * add a profile here, register its ObjectConfig code on its menu, and give the tenant a
 * notification service whose query reads the request rows (Remarks = requestKey).
 */
export const DOC_EMAIL_PROFILES: DocEmailProfile[] = [SALE_QUOTATION];

export function findDocEmailProfile(masterType: string | null | undefined): DocEmailProfile | undefined {
  const key = (masterType || '').trim().toLowerCase();
  return DOC_EMAIL_PROFILES.find(p => p.masterType.toLowerCase() === key);
}
